
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affiliation/affiliationMarket/[productCode]",
      function () {
        return require("private-next-pages/affiliation/affiliationMarket/[productCode].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affiliation/affiliationMarket/[productCode]"])
      });
    }
  